export const ActionTypes = {
    UPDATE_TIMELINE: "UPDATE_TIMELINE_REQUEST",
    UPDATE_TIMELINE_SUCCESS: "UPDATE_TIMELINE_SUCCESS",
    UPDATE_TIMELINE_FAILURE: "UPDATE_TIMELINE_FAILURE",
}